<script>
    export default{
        data(){
            return{
                dados:{}
            }
        },
        ready: function()
        {
            var self = this;
            //json com os dados do header
            $.getJSON('./../server/headerservicos.php', function(dados)
            {                
                self.dados = dados[0];
                //console.log(self.dados)
            });
        }
    }
</script>
<template>        
<!-- header begin -->
            <header class="site-header-3 site-header">
                <!-- Main bar start -->
                <div id="sticked-menu" class="main-bar">
                    <div class="container">                
                        <div class="row">                    
                            <div class="col-md-12">
                                <!-- logo begin -->
                                <div id="logo" class="site-logo">                            
                                    <a :href="dados.linklogo">
                                        <img :src="dados.imglogo" alt="" class="logo logo-principal">
                                        <div class="nomes-logo">
                                            <span>{{ dados.tipoentidade}}</span>
                                            <h1>{{dados.nomeentidade}}</h1>
                                        </div>
                                    </a>
                                </div>
                                <!-- logo close -->
                                <div class="title-system pull-right" style="">
                                    <p class="title-ouvi">{{dados.nomesistema}}</p>
                                    <p class="sub-title-ouvi">{{dados.subtitulosistema}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
            <!-- header close -->
          <div class="gray-line"></div>
</template>
<style>
    
</style>



// WEBPACK FOOTER //
// header.vue?46c37003